import { createContainer } from 'react-sweet-state';

import { AnnotationStore } from './AnnotationStore';

export const AnnotationStoreContainer = createContainer(AnnotationStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
